enum AgencyBilledQuantity {
  Partial,
  All,
  None,
}

export default AgencyBilledQuantity;
